import { createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/_landing/$locale/")({
  beforeLoad: () => {
    throw notFound();
  },
});
